require("app/util/config/chartjs-config");
const Chartjs = require("chart.js");

const Chart = React.createClass({
  propTypes: {
    type: React.PropTypes.oneOf(["line", "horizontalBar", "pie"]).isRequired,
    colorSet: React.PropTypes.string,
    datasets: React.PropTypes.array.isRequired,
    labels: React.PropTypes.array,
    options: React.PropTypes.object,
    style: React.PropTypes.object,
    plugins: React.PropTypes.array
  },

  getDefaultProps: function() {
    return ({
      colorSet: "A",
      labels: [],
      style: {},
      plugins: []
    });
  },

  componentDidMount: function() {
    let ctx = this.refs.canvas.getContext("2d");

    this.chart = new Chartjs(ctx, {
      type: this.props.type,
      colorSet: this.props.colorSet,
      plugins: this.props.plugins,
      data: {
        labels: this.props.labels,
        datasets: this.props.datasets
      },
      options: this.props.options
    });
  },

  componentDidUpdate: function(prevProps) {
    if (this.props != prevProps) {
      this.chart.config.data.labels = this.props.labels;
      this.props.datasets.forEach((dataset, index) => {
        let originalDataset = this.chart.data.datasets[index];

        if (originalDataset) {
          for (let [key, value] of Object.entries(dataset)) {
            originalDataset[key] = value;
          }
        }
        else
          this.chart.data.datasets.push(dataset)
      })

      if (prevProps.datasets.length > this.props.datasets.length) {
        const difference = prevProps.datasets.length - this.props.datasets.length;
        this.chart.data.datasets.splice(-difference);
      }

      this.chart.update();
    }
  },

  render: function() {
    return (
      <div className="p-r w-100pct" style={this.props.style}>
        <canvas ref="canvas" />
      </div>
    );
  }
});

module.exports = Chart;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/Chart/chart.jsx